import React, {FC} from "react"

import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {Branding} from "@irati/types"
import {BusinessLogo} from "../../containers/OneTimePassword/styled"

import {HeaderLogo} from "../CheckEmail/styled"

interface Props extends InjectIntl, WithBranding {
  branding: Branding
}
const ResetPasswordError: FC<Props> = ({branding, formatMessage}) => {
  return (
    <>
      <Alert type={AlertTypes.info} title="platform.resetPassword.invalidLink.alertTitle" />
      <Flex alignContent="center" justifyContent="center">
        {branding.businessLogoUrl && (
          <Flex justifyContent="center" alignContent="center" marginTop>
            <BusinessLogo src={formatMessage({id: branding.businessLogoUrl})} />
          </Flex>
        )}
      </Flex>
      <Flex alignContent="center" justifyContent="center">
        <HeaderLogo src={formatMessage({id: "platform.resetPassword.invalidLink.logo"})} />
      </Flex>
      <Body small weight="bold" textAlign="center" maxWidth="100%">
        <FormattedMessage id="platform.oops.header.text" />
      </Body>
      <Body small textAlign="center" maxWidth="100%">
        <FormattedMessage id="platform.resetPassword.header.text" />
      </Body>
      <Flex alignContent="center" justifyContent="center" marginTop={2} marginBottom>
        <ButtonRouterLink full to="/welcome/login/forgotten-password" primary>
          <FormattedMessage id="platform.resetPassword.link.text2" />
        </ButtonRouterLink>
      </Flex>
    </>
  )
}

export default withBranding(injectIntl(ResetPasswordError))
